import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface NavItem {
  text: string;
  logo: React.ReactNode;
  link?: string;
  onClick?: () => void;
}

interface LeftBarProps {
  items: NavItem[];
  hide?: boolean;
}

const LeftBar: React.FC<LeftBarProps> = ( { items, hide = false } ) => {
  const navigate = useNavigate();
  const [ hoveredItem, setHoveredItem ] = useState<string | null>( null );
  const [ isMenuHover, setisMenuHover ] = useState<boolean>( false );

  const handleNavigation = ( link: string ) => {
    navigate( link );
  };

  return (
    <div className='shrink-0 w-20'>
      <div className={`mr-20 fixed top-0 left-0 w-20 h-full z-30 shadow-md ${hide ? 'hidden' : 'flex'}`}>
        <div
          className='rounded-lg flex max-h-screen z-30 relative'
          onMouseEnter={() => {return setisMenuHover( true );}}
          onMouseLeave={() => {return setisMenuHover( false );}}
        >
          <div className='flex-col flex bg-white dark:bg-dark-bg2 items-center border-r-[1px] dark:border-dark-bg-light text-orange-600 h-full w-20 z-[29]'>
            {items.map( ( item, index ) => {return (
              <button
                key={index}
                className={`pl-2 w-full h-full flex-center ${hoveredItem === item.text ? 'text-orange-600' : ''
                }`}
                onClick={() => {
                  if ( item.onClick ) {
                    item.onClick();
                  }
                  if ( item.link ) {
                    handleNavigation( item.link );
                  }
                }}
                onMouseEnter={() => {return setHoveredItem( item.text );}}
                onMouseLeave={() => {return setHoveredItem( null );}}
              >
                <div
                  className='p-2'
                >
                  {item.logo}
                </div>
                <hr
                  className={`h-10 w-1 ml-2 border-none rounded-full ease-in-out duration-300 ${hoveredItem === item.text ? 'bg-orange-200' : 'bg-transparent'
                  }`}
                ></hr>
              </button>
            );} )}
          </div>

          <div
            className={`flex -left-52 flex-col text-xl w-64 pr-2 bg-gray-100 shadow-md shadow-gray-400 absolute ${isMenuHover ? 'left-full' : ''
            } h-full transition-all duration-400 delay-0`}
          >
            {items.map( ( item, index ) => {return (
              <button
                key={index}
                className='h-full flex items-center'
                onClick={() => {
                  if ( item.onClick ) {
                    item.onClick();
                  }
                  if ( item.link ) {
                    handleNavigation( item.link );
                  }
                }}
                onMouseEnter={() => {return setHoveredItem( item.text );}}
                onMouseLeave={() => {return setHoveredItem( null );}}
              >
                <div
                  className={`relative overflow-hidden ease-in-out duration-200 px-4 w-full text-left py-1.5 rounded-r-xl ${hoveredItem === item.text ? 'text-orange-600' : ''
                  }`}
                >
                  <span
                    className={`absolute inset-0 transition-transform duration-300 ease-in-out ${hoveredItem === item.text
                      ? 'transform translate-x-0'
                      : 'transform -translate-x-full'
                    } bg-orange-200`}
                  ></span>
                  <p className='z-[28] relative'>{item.text}</p>
                </div>
              </button>
            );} )}
          </div>
        </div>
        <div>
          <div
            className={`absolute h-screen opacity-25 bg-gray-500 ${isMenuHover ? 'w-screen' : 'w-0'
            }`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LeftBar;
